import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";
import {
  creaInstitucion,
  CreaInstitucion,
  obtenerDepartamento,
  obtenerMunicipio,
  obtenerTipoInstitucion,
} from "../Services/Rest";
import axios from "axios";

function CrearSolicitud() {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [tipoInstitucion, setTipoInstitucion] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: obtenerTipoInstitucion,
    })
      .then((Response) => {
        setTipoInstitucion(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setTipoInstitucion]);
  const [municipio, setCiudad] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      url: obtenerMunicipio,
    })
      .then((Response) => {
        setCiudad(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setCiudad]);
  const [departamento, setDepartamento] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      url: obtenerDepartamento,
    })
      .then((Response) => {
        setDepartamento(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setDepartamento]);
  const [postRazonSocial, setPostRazonSocial] = useState([]);
  const [postNit, setPostNit] = useState([]);
  const [postTipoInstitucion, setPostTipoInstitucion] = useState([]);
  const [postDireccion, setPostDireccion] = useState([]);
  const [postCiudad, setPostCiudad] = useState([]);
  const [postDepartamento, setPostDepartamento] = useState([]);
  const [postFechaAcreditacion, setPostFechaAcreditacion] = useState([]);
  const [postFechaRenovacion, setPostFechaRenovacion] = useState([]);
  const [postCodigo, setPostCodigo] = useState([]);
  const [postTelefono, setPostTelefono] = useState([]);

  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      url: creaInstitucion,
      data: {
        InstitucionId: postTipoInstitucion,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert("Institucion creada con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear Institucion");
      });
  };

  return (
    <div>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Repositorio de los documentos
                </h6>
              </div>
              <div class="card-body">
                <div class="table-responsive"></div>

                <form className="user">
                  <div className="form-group row">
                    <div className="col-sm-6 mb-3 mb-sm-0">
                      <input
                        type="text"
                        className="form-control form-control-user"
                        placeholder="Razon social"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <input
                      type="number"
                      className="form-control form-control-user"
                      placeholder="Nit"
                    />
                  </div>
                  <div className="form-group row">
                    <div className="col-sm-6 mb-3 mb-sm-0">
                      <input
                        type="text"
                        className="form-control form-control-user"
                        placeholder="Direccion"
                      />
                    </div>
                    <div className="col-sm-6">
                      <select
                        className="btn btn-secondary btn-user btn-block"
                        onChange={(e) => setPostTipoInstitucion(e.target.value)}
                      >
                        <option value="">Tipo Institucion</option>
                        {tipoInstitucion.map((item) => (
                          <option value={item.id}>{item.tipo}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-sm-6 mb-3 mb-sm-0">
                      <select
                        className="btn btn-secondary btn-user btn-block"
                        onChange={(e) => setPostCiudad(e.target.value)}
                      >
                        <option value="">Municipio</option>
                        {municipio.map((item) => (
                          <option value={item.id}>{item.municipio}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-sm-6">
                      <select
                        className="btn btn-secondary btn-user btn-block"
                        onChange={(e) => setPostDepartamento(e.target.value)}
                      >
                        <option value="">Departamento</option>
                        {departamento.map((item) => (
                          <option value={item.id}>{item.departamento}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-sm-6 mb-3 mb-sm-0">
                      Fecha acreditacion
                      <input
                        type="date"
                        className="form-control form-control-user"
                        placeholder="acreditacion"
                      />
                    </div>
                    <div className="col-sm-6">
                      Fecha renovacion
                      <input
                        type="date"
                        className="form-control form-control-user"
                        placeholder="Renovacion"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control form-control-user"
                      placeholder="correo"
                    />
                  </div>
                  <div className="form-group row">
                    <div className="col-sm-6 mb-3 mb-sm-0">
                      <input
                        type="number"
                        className="form-control form-control-user"
                        placeholder="codigo"
                      />
                    </div>
                    <div className="col-sm-6">
                      <input
                        type="number"
                        className="form-control form-control-user"
                        placeholder="telefono"
                      />
                    </div>
                  </div>
                  <a>
                    <button
                      className="btn btn-primary btn-user btn-block"
                      onClick={postData}
                    >
                      Guardar
                    </button>
                  </a>
                  <hr />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CrearSolicitud;
